<template>
  <BModal
    :active="isOpen"
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    :width="1300"
    aria-role="dialog"
    aria-modal
  >
    <div class="full-calendar">
      <div class="close-button" @click="onClickClose">
        <span class="close-button__text">Cerrar</span>
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_close.png" alt="close" width="12" />
      </div>
      <ActiveTimeCalendar
        id="fc3"
        :seasons="seasons"
        :is-short-version="false"
        :pre-selected-round="preSelectedRound"
        :is-cup="isCup"
        :is-cup-legacy="isCupLegacy"
        @action="onClickViewStats"
      />
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'FullCalendar',
  components: {
    ActiveTimeCalendar: () => import('@/components/ActiveTime/ActiveTimeCalendarComponent'),
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    preSelectedRound: {
      type: String,
      default: '',
    },
    seasons: {
      type: [Object, Array],
      default: () => {},
    },
    isCup: {
      type: Boolean,
      default: false,
    },
    isCupLegacy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // seasons: [
      //   { id: 1535, type: 0 },
      //   { id: 1591, type: 2 },
      //   { id: 1594, type: 1 },
      // ],
    };
  },
  methods: {
    onClickViewStats(val) {
      this.$emit('action', val);
    },
    onClickClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.full-calendar {
  background-color: white;
  padding: 2.6em;
  border-radius: 10px;
  position: relative;

  @media screen and (max-width: 910px) {
    padding: 2.6em 0.1em;
  }
}
.close-button {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  width: 87px;
  height: 25px;
  font-family: Roboto-Regular, sans-serif;
  border-radius: 25px;
  background-color: #132839;
  right: 7px;
  top: 6px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: -0.15px;
  text-align: center;
  color: #fff;

  & > span {
    margin-right: 0.5em;
  }
}
</style>
